import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

// packages
import parse from "html-react-parser";
import MathJax from "react-mathjax-preview";
import CustomPagination from "components/CustomPagination ";
import TableFilters from "components/TableFilters";

// components
import PageHeader from "components/BreadCrumb";

// hooks
import { useDeleteQuestion, useGetQuestions } from "hooks/api/subject";
import { useTable } from "hooks/custom/useTable";

// context
import { useAuthContext } from "context/auth.context";

//
import {
  dataReviewUser,
  defaultAdminPermissions,
  defaultEntryPermissions,
} from "constant";
import { CSVLink } from "react-csv";
import StudentFilters from "components/TableFilters/StudentFilters";
import { useDeleteStudent, useGetTopStudents } from "hooks/api/students";

const Students = () => {
  const history = useHistory();
  const { user } = useAuthContext();

  const [rows, setRows] = useState([]);
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable();

  const [board, setBoard] = useState();
  const [sClasses, setSClasses] = useState();
  const [subject, setSubject] = useState();
  const [campuses, setcampuses] = useState(); 
  
  const {
    data: students,
    refetch,
    isLoading,
  } = useGetTopStudents(user?.user_group_id, board, sClasses, campuses);

  useEffect(() => {
    if (board) {
      refetch();
    }
    if (sClasses) {
      refetch();
    }
    if (campuses) {
      refetch();
    }
  }, [board, sClasses, campuses, refetch]);

  const deleteStudents = useDeleteStudent(refetch);

  const formatDataForCSV = () => {
    return (
      students?.data?.map((row) => ({
        "No. of Quizzes": row.quizes?.length,
        Name: row.name,
        Percentage: `${row.percentage}%`,
        Average: row.average,
        Grades: row.grade,
        Marks: `${row.quizes_marks}/${row.quizes?.length * 10}`,
        Class: row.classType == "1" ? "IX - 9th" : "X - 10th",
        Email: row.email,
      })) || []
    );
  };

  return (
    <div className="container-fluid">
      <PageHeader HeaderText="Students" Breadcrumb={[{ name: "Students" }]} />

      <div className="card">
        <div
          className="header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>All Students</h2>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <CSVLink
              filename={"students-table-data.csv"}
              data={formatDataForCSV()}
              asyncOnClick={true}
              onClick={(event, done) => {
                if (!students?.data?.length) {
                  alert("No data to export");
                  done(false);
                } else {
                  done();
                }
              }}
            >
              <button type="button" className="btn btn-primary">
                <span className="mx-1">Export Students</span>
                <i className="fa fa-download"></i>
              </button>
            </CSVLink>

            {defaultEntryPermissions.includes(user.rolename.toLowerCase()) && (
              <Link to="/students/create">
                <button
                  type="button"
                  className="btn btn-success"
                  title="Add Student"
                >
                  <span className="sr-only">Create Student</span>
                  <i className="fa fa-plus mr-1"></i>{" "}
                  <span>Add Student</span>
                </button>
              </Link>
            )}
          </div>
        </div>

        <StudentFilters
          data={students?.data || []}
          board={board}
          setBoard={setBoard}
          campuses={campuses}
          sClasses={sClasses}
          setSClasses={setSClasses}
          setSubject={setSubject}
          setcampuses={setcampuses}
          searchKey="question"
          contextKey="QUESTION_FILTERS"
          isLoading={isLoading}
          showCampus
          showChapters
          showTopics
          showTypes
        />

        <div className="body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>No. of Quizzes</th>
                  <th>Name</th>
                  <th>Percentage</th>
                  <th>Average</th>
                  <th>Grades</th>
                  <th>Marks</th>
                  <th>Class</th>
                  <th>Email</th>
                  <th style={{ textAlign: "end" }}>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td
                      style={{
                        textAlign: "center",
                        height: "30vh",
                        width: "100%",
                      }}
                      className="visible-lg"
                    >
                      <i className="fa fa-spinner fa-4x fa-spin"></i>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                ) : (
                  <>
                    {students?.data?.length > 0 ? (
                      students?.data?.map((row) => (
                        <tr key={row.id}>
                          <th scope="row">{row.quizes?.length}</th>
                          <th scope="row">{row.name}</th>
                          <td>{row.percentage}%</td>
                          <td>{row.average}</td>
                          <td>{row.grade}</td>
                          <td>
                            {row.quizes_marks}/{row.quizes?.length * 10}
                          </td>
                          <td>
                            {row.classType == "1" ? "IX - 9th" : "X - 10th"}
                          </td>
                          <td>{row.email}</td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <button
                                type="button"
                                className="btn btn-primary mr-1"
                                title="View"
                                onClick={() =>
                                  history.push(`/students/quizzes/${row.id}/${row.classType}`)
                                }
                              >
                                <span className="sr-only">View</span>
                                <i className="fa fa-eye"></i>
                              </button>

                              {defaultEntryPermissions.includes(
                                user.rolename.toLowerCase()
                              ) && (
                                <button
                                  type="button"
                                  className="btn btn-warning"
                                  title="Edit"
                                  onClick={() =>
                                    history.push(`/students/edit/${row.id}`)
                                  }
                                >
                                  <span className="sr-only">Edit</span>
                                  <i className="fa fa-edit"></i>
                                </button>
                              )}

                              {defaultAdminPermissions.includes(
                                user.rolename.toLowerCase()
                              ) && (
                                <button
                                  type="button"
                                  className="btn btn-danger ml-1"
                                  title="Delete"
                                  onClick={() => deleteStudents.mutate(row.id)}
                                >
                                  <span className="sr-only">Delete</span>
                                  <i className="fa fa-trash-o"></i>
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td
                          style={{
                            textAlign: "center",
                            height: "30vh",
                            fontSize: "1.5rem",
                            width: "100%",
                          }}
                        >
                          Oops! No data found
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="body" style={{ paddingTop: 0, paddingBottom: 0 }}>
          <CustomPagination
            count={students?.data?.length}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Students;
